import { render, staticRenderFns } from "./GoogleAd.vue?vue&type=template&id=2c394104&"
import script from "./GoogleAd.vue?vue&type=script&lang=js&"
export * from "./GoogleAd.vue?vue&type=script&lang=js&"
import style0 from "./GoogleAd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports